<template>
<div class="MStimulateStep">
    <Header2></Header2>
    <div class="container_box">
        <el-steps :active="stepValue" align-center>
            <el-step title="基本信息"></el-step>
            <el-step title="持股方式/来源"></el-step>
            <el-step title="相关要素"></el-step>
            <el-step title="生成报告"></el-step>
        </el-steps>
    </div>
    <div class="step_warp">
        <MStepOne :formParams="formParams" @setTipsPopInfo='setTipsPopInfo' @setStepValue="setStepValue" v-show="stepValue === 0"></MStepOne>
        <MStepTwo :formParams="formParams" @setTipsPopInfo='setTipsPopInfo' @setStepValue="setStepValue" v-show="stepValue === 1" ref="msteptwocomponents"></MStepTwo>
        <MStepThree :stepValue="stepValue" :formParams="formParams" @setTipsPopInfo='setTipsPopInfo' @setStepValue="setStepValue" @GenerateReports="GenerateReports" v-show="stepValue === 2" ref="mstepthreecomponents"></MStepThree>
        <MStepFour :formParams="formParams" v-show="stepValue === 3" ref="mstepfourcomponents"></MStepFour>
    </div>

    <div class="tips_pop_warp">
        <van-popup v-model="showTipsPop">
            <div class="tips_box">
                <p class="p_title">{{tipsTitle}}</p>
                <p class="p_desc" v-html="tipsDesc"></p>
            </div>
        </van-popup>
    </div>
</div>
</template>

<script>
import {dealSwSiOrderinfo} from 'api/gujingApi'
import Header2 from 'views/gjMobile/components/Header2'
import MStepOne from 'views/gjMobile/mExcitationTool/components/MStepOne'
import MStepTwo from 'views/gjMobile/mExcitationTool/components/MStepTwo'
import MStepThree from 'views/gjMobile/mExcitationTool/components/MStepThree'
import MStepFour from 'views/gjMobile/mExcitationTool/components/MStepFour'
import {mapGetters, mapActions} from 'vuex'
export default {
    name: 'MStimulateStep',
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=2,user-scalable=no' }
        ]
    },
    data() {
        return {
            stepValue: 0,
            showTipsPop: false,
            tipsTitle: '',
            tipsDesc: '',
            formParams: {
                companyname: '',  // 公司名称
                regcapital: '',  // 注册资本-万元
                holdingtype: 1,  // 持股方式 1 通过自然人持股 2 通过有限公司持股 3 通过有限合伙企业持股
                ischangereg: '',  // 是否工商变更 0否 1是
                sharesource: '',  // 激励股份来源： 1 增资扩股 2 单一原股东转让 3 全体原股东等比例转让
                totalrate: '',  // 激励总量比例%
                totalsicount: '',  // 激励总量
                firstrate: '',  // 首次激励总量占总公司股份比例%
                firstsicount: '',  // 首次激励股份总量
                surrate: '',  // 预留股份占总公司股份比例
                sursicount: '',  // 预留激励总量占公司股份总量
                evmoney: '',  // 目前估值（万元）
                usercode: '', // (用户输入的验证码)
                codeEncryption: '' // 加密后的验证码
            }
        }
    },
    mounted() {},
    methods: {
        // 股权激励第三步 正式生成报告
        GenerateReports() {
            if (this.formParams.ischangereg === '') {
                this.formParams.ischangereg = 0
            }
            this.setLoading(true)
            let params = {}
            dealSwSiOrderinfo({
                data: Object.assign({}, params, this.formParams),
                success: data => {
                    // console.log(data)
                    this.setLoading(false)
                    this.stepValue = 3
                    this.$refs.mstepfourcomponents.getResultData(data.data)
                },
                error: data => {
                    this.$toast.fail(data.msg)
                }
            })
        },
        // 显示对应提示弹窗 及标题和内容
        setTipsPopInfo(tit, des) {
            this.tipsTitle = tit
            this.tipsDesc = des
            this.showTipsPop = true
        },
        // 设置估值流程的步骤
        setStepValue(val) {
            this.stepValue = val
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        Header2,
        MStepOne,
        MStepTwo,
        MStepThree,
        MStepFour
    }
}
</script>

<style lang="scss" type="text/scss">
.MStimulateStep {
    padding-top: 1rem;
    box-sizing: border-box;
    min-height: 100vh;
    background-color: #F5F7FA;
    .container_box {
        padding: 1rem 0.32rem;
        padding: 0.4rem 0;
        background-color: #fff;
        .el-steps {
            // .el-step {
            //     width: 125px;
            // }
            .el-step__line-inner {
                border-width: 1px!important;
                border-color: #409EFF;
            }
            .el-step__line {
                height: 0.03rem;
                top: 0.2rem;
            }
            .el-step__line {
                background-color: #EAEFF6;
            }
            .el-step__icon {
                background-color: #EAEFF6;
                border-color: #EAEFF6;
                width: 0.4rem!important;
                height: 0.4rem!important;
            }
            .el-step__icon-inner {
                color: #FFF;
                font-weight: normal;
                font-size: 0.24rem;
            }
            .el-step__title {
                font-size: 0.28rem;
            }
            .is-finish{
                .el-step__line {
                    background-color:#409EFF;
                }
            }
            .is-finish, .is-process {
                color: #108EE9;
                .el-step__icon {
                    background-color: #108EE9;
                    border-color: #108EE9;
                }
                .el-step__icon-inner {
                    color: #FFF;
                }
            }
        }
    }
    .step_warp {
        padding: 0.32rem;
        background-color: #F5F7FA;
        .content_warp {
            background-color: #fff;
            padding: 0.32rem;
            padding-top: 0.02rem;
            .type_box {
                .row_box {
                    border-bottom: 0.01rem solid #E5E5E5;
                    padding-top: 0.3rem;
                    padding-bottom: 0.12rem;
                    .title_text {
                        color: #333;
                        font-size: 0.32rem;
                        line-height: 0.46rem;
                        padding-bottom: 0.08rem;
                        display: flex;
                        align-items: center;
                        &>img {
                            margin-left: 0.2rem;
                            width: 0.22rem;
                            height: 0.22rem;
                        }
                    }
                    .van-cell{
                        padding: 0.2rem 0;
                        font-size: 0.32rem;
                    }
                    .auth_code_img {
                        width: 1.6rem;
                        height: 0.68rem;
                    }
                }
                .row_box:nth-last-of-type(1){
                    border-bottom: none;
                    padding-bottom: 0;
                    .van-cell{
                        padding-bottom: 0;
                    }
                }
            }
        }
    }
    .tips_pop_warp {
        .van-popup{
            width: 5.6rem;
            border-radius: 0.1rem;
        }
        .tips_box {
            border-radius: 0.5rem;
            padding: 0.4rem 0.22rem;
            display: flex;
            flex-direction: column;
            align-items: center;
            .p_title {
                margin-bottom: 0.32rem;
                font-size: 0.36rem;
                line-height: 0.5rem;
                text-align: center;
                // font-weight: bold;
            }
            .p_desc {
                padding: 0 0.18rem;
                font-size: 0.32rem;
                line-height: 0.54rem;
                color: #666;
                text-align: justify;
                &>span{
                    font-weight: bold;
                }
            }
        }
    }
}
</style>